import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'email',
})
export class EmailPipe implements PipeTransform {
  transform(value: any, args?: any): string {
    if (!value) {
      return '';
    }

    return value.emails && value.emails[0] ? value.emails[0].email : '';
  }
}
